import { PlusIconBorderless } from "$components/icons";
import { useAnalytics } from "$global-providers/analytics-provider/provider";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import { VaccinationInitiatedFrom } from "../vaccinations/_lib/analytics";
import { linkToNewVaccination } from "../vaccinations/links";
import { RecommendationsBox } from "./recommendations-box";
import { useVaccinationsService } from "./vaccinations-service/provider";
import { allVaccineCodesToDetailsMap } from "./vaccinations-service/vaccination-schedule";
export const RecommendedVaccinesCard: React.FC = () => {
  const { trackEvent } = useAnalytics();
  const { getPatientRecommendedVaccines, patient } = useVaccinationsService();

  const navigate = useNavigate();

  const handleClick = (
    _event: React.MouseEvent<HTMLElement>,
    actionId: string,
  ) => {
    trackEvent("Vaccination Started", {
      patientId: patient.id,
      initiatedFrom: VaccinationInitiatedFrom.RECOMMENDATION_CARD,
      initialVaccineCode: actionId,
    });

    navigate(linkToNewVaccination({ patientUuid: patient.id }), {
      state: { formState: { vaccinations: [{ code: actionId }] } },
    });
  };

  const patientVaccines = getPatientRecommendedVaccines();

  if (patientVaccines.length === 0) return null;

  const recommendations = patientVaccines.map((vaccine) => ({
    id: vaccine.code,
    startIcon: <PlusIconBorderless />,
    label: (
      <FormattedMessage
        defaultMessage="{vaccineDisplayName}"
        id="patient.new.vaccination.form.recommendedVaccines.recommendedVaccine"
        values={{
          vaccineDisplayName:
            allVaccineCodesToDetailsMap[vaccine.code].displayName ??
            vaccine.code,
        }}
      />
    ),
  }));

  return (
    <RecommendationsBox
      TitleText={
        <FormattedMessage
          id={"patient.new.vaccination.form.recommendedVaccines.title"}
          defaultMessage={"Vaccinations due"}
        />
      }
      recommendations={recommendations}
      handleClick={handleClick}
    />
  );
};
